import React from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import SelectInput from "./SelectInput";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { faSearch } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { statuses, transformLowdash } from "../helpers";
import Button from "./CustomButton";

const propTypes = {
  submitting: PropTypes.bool.isRequired,
  failSubmit: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object
};

const states = statuses.map(status => ({
  value: status,
  label: transformLowdash(status)
}));

const SearchContractForm = ({
  onSubmit,
  initialValues,
  submitting,
  failSubmit
}) => {
  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      render={({ values, submitForm }) => {
        return (
          <div>
            <Form>
              {failSubmit && <Alert color="danger">{failSubmit}</Alert>}
              <div className="row align-items-start">
                <div className="col-md-4 col-sm-6 col-xs-12 pr-md-1">
                  <Field
                    name="from_date"
                    placeholder="From Date"
                    type="date"
                    component={TextInput}
                  />
                </div>
                <div className="col-md-4 col-sm-6 col-xs-12 px-md-1">
                  <Field
                    name="to_date"
                    placeholder="To Date"
                    type="date"
                    component={TextInput}
                  />
                </div>
                <div className="col-md-4 col-sm-6 col-xs-12 pl-md-1">
                  <Field
                    name="tracking_number"
                    component={TextInput}
                    placeholder="Tracking Number"
                  />
                </div>
                <div className="col-md-5 col-sm-6 col-xs-12 pr-md-1">
                  <Field
                    name="customer"
                    component={TextInput}
                    placeholder="Enter name, email, or phone number"
                  />
                </div>
                <div className="col-md-3 col-sm-6 col-xs-6 px-md-1">
                  <Field
                    name="aasm_state"
                    component={SelectInput}
                    source={states}
                    placeholder="Contract State"
                  />
                </div>
                <div className="col-md-3 col-sm-6 col-xs-6 px-md-1">
                  <Field
                    name="key_tag"
                    component={TextInput}
                    placeholder="Key Tag"
                  />
                </div>
                <div className="col-md-3 col-sm-6 col-xs-6 px-md-3">
                  <Field
                    name="repair_order_no"
                    component={TextInput}
                    placeholder="Repair Order #"
                  />
                </div>
                <div className="col-md-2 col-sm-12 col-xs-12 pl-md-1">
                  <Button
                    fill
                    block
                    type="submit"
                    onClick={submitForm}
                    disabled={submitting}
                    color="info"
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        );
      }}
    />
  );
};

SearchContractForm.propTypes = propTypes;

const validate = values => {
  let errors = {};
  return errors;
};

export default SearchContractForm;
